<template>
  <div class="fts-list-designer">
    <!-- header -->
    <div class="list-designer-header">
      <div class="list-designer-header-l">
        <div class="list-designer-header-title">{{title}}</div>
      </div>
      <fts-btn text icon @click="openColumnsSelection">
        <font-awesome-icon :icon="['fas', 'edit']" fixed-width /> 
      </fts-btn>
    </div>
    <!-- content -->
    <div class="list-designer-content fts-scrollbar">
      <fts-list-designer-layouter
        :list="list"
        :wrap="false"
        class="list-designer-columns" 
        @input="onInput"
      />
    </div>
    <!-- overlay -->
    <div class="list-designer-overlay" v-if="list.columns && !list.columns.length" @click="openColumnsSelection">
      <div class="overlay-label">Click to customize your list !</div>
    </div>
    <!-- listing column design modal -->
    <fts-listing-column-design-modal
      :title="title"
      :columns="list.columns"
      ref="ftsListingColumnDesignModal"
    />
  </div>
</template>

<script>
import FTSBtn from '../elements/FTSBtn';
import FTSListDesignerLayouter from './FTSListDesignerLayouter';
import FTSListingColumnDesignModal from './FTSListingColumnDesignModal';

export default {
  props: {
    title: {
      type: String,
      default: "List design"
    },
    informationSource: {
      type: Array,
      default: () => []
    },
    list: {
      type: Object,
      default: () => ({})
    }
  },
  model: {
    prop: "list",
    event: "updateList",
  },
  components: {
    "fts-btn": FTSBtn,
    "fts-list-designer-layouter": FTSListDesignerLayouter,
    "fts-listing-column-design-modal": FTSListingColumnDesignModal
  },
  methods: {
    onInput() {
      this.$emit('input');
    },
    async openColumnsSelection() {
      const res = await this.$refs.ftsListingColumnDesignModal.show(this.informationSource);
      if (res !== null && res !== true) {
        const listingAction = this.list.columns.find(x => x.id === "action" && x.system);
        res.forEach(selectItem => {
          if (
            !this.list.columns.some(x =>
              x.fieldName == selectItem.fieldName &&
              x.system == selectItem.system
            )
          ) {
            delete selectItem.selected;
            this.list.columns.push(selectItem);
          }
        });

        let columns = this.list.columns.slice();
        columns.forEach(column => {
          if (
            !res.some(
              x => x.fieldName == column.fieldName && x.system == column.system
            )
          ) {
            let ind = this.list.columns.indexOf(column);
            this.list.columns.splice(ind, 1);
          }
        });

        if (listingAction)
          this.list.columns.push(listingAction);

        this.onInput();
      } else if (res === true) {
        this.list.columns = [];
      }
    },
  },
  mounted() {
    if (!Array.isArray(this.list.columns)) {
      this.$emit('updateList', {columns: []})
    }
  }
};
</script>

<style lang="scss" scoped>
@use "./src/assets/scss/vars" as *;
@use "./src/assets/scss/colors" as *;

.fts-list-designer {
  position: relative;
  border-radius: 0.25rem;
  background-color: var(--fts-card-background);
  box-shadow: var(--fts-elevation-1);
  .list-designer-header {
    display: flex;
    align-items: center;
    padding: 1rem 1rem 0;
    .list-designer-header-l {
      flex: 1;
      margin-right: .75rem;
      .list-designer-header-title {
        font-size: 1rem;
        font-weight: 500;
        color: var(--fts-text);
      }
    }
  }
  .list-designer-content {
    min-height: 90px;
    display: flex;
    .list-designer-columns {
      padding: 0 1rem 1rem;
    }
  }
  .list-designer-overlay {
    @include flex-center-middle;
    @include position($top: 0, $left: 0, $right: 0, $bottom: 0);
    @include theme() {
      background-color: rgba(theme-get('fts-card-background'), 0.85);
    }
    border-radius: inherit;
    cursor: pointer;
    .overlay-label {
      font-weight: 500;
      font-size: 1rem;
      color: var(--fts-text);
    }
  }
}
</style>